import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { FeatureFlagKey } from '../../types/featureFlags';
import { useFeatureFlags } from './useFeatureFlags';

interface RequireFeatureProps {
  flag: FeatureFlagKey;
  children: ReactNode;
  /** Where to send a user whose flag is off. The dashboard by default. */
  redirectTo?: string;
}

/**
 * Route guard for a flagged page. While the flag is off the page reads as absent, so a bookmark or
 * a pasted link lands on the dashboard, the same as the API answering 404.
 *
 * Renders nothing until the flags have loaded, so a deep link is not bounced before the answer.
 */
export const RequireFeature = ({ flag, children, redirectTo = '/players' }: RequireFeatureProps) => {
  const { status, isEnabled } = useFeatureFlags();
  if (status === 'loading') return null;
  if (!isEnabled(flag)) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
};
